import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { MaskedSafetyImage } from '../../images'
import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { HELP_URL } from '../../../../../constants'
import { ImageContainer } from '../../styles'
import { CommonTextUrl } from '../../../../atoms/common-text-url'

export const SafetySection = () => (
  <SectionContainer>
    <ImageContainer>
      <MaskedSafetyImage />
    </ImageContainer>
    <Text styles={Text.Styles.Bold32}>
      {i18n.t(i18nKeys.safetyCourse__title_safety)}
    </Text>
    <ContentText>
      <Interpolate
        i18n={i18n}
        i18nKey={i18nKeys.safetyCourse__description1_safety}
        components={[
          <Text
            weight={Text.Weights.Bold}
            display={Text.DisplayModes.Inline}
            styles={Text.Styles.SectionSubtext}
          />,
        ]}
      />
    </ContentText>
    <ContentText>
      <Interpolate
        i18n={i18n}
        i18nKey={i18nKeys.safetyCourse__description3_safety}
        components={[<CommonTextUrl url={HELP_URL} />]}
      />
    </ContentText>
  </SectionContainer>
)
